/*document.querySelectorAll('[data-href]').forEach((divLink: HTMLElement) => {
    divLink.onclick = (): void => {
        window.location.href = divLink.dataset.href;
    };
});*/

document.body.addEventListener('click', (e) => {
    const href = e.target.dataset?.href || e.target.closest('[data-href]')?.dataset.href;

    if (href) {
        window.location.href = href;
    }

    const share = (e.target.classList.contains('share')) ? e.target : e.target.closest('.share');
    if (share) {
        share.classList.toggle('is-active');
    }
});

document.querySelectorAll('.button.back').forEach(back => {
    back.addEventListener('click', (e) => {
        if (document.referrer.indexOf(host) !== -1) {
            e.preventDefault();
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = document.referrer;
            }
        }
    })
});


if (document.body.classList.contains('template_series_detail')) {
    document.addEventListener("scroll", (event) => {
        document.querySelector('.detail-nav').classList.toggle('is-scrolled', window.scrollY !== 0);
    });
}


window.handleVideos = function handleVideos() {
    document.querySelectorAll('.video').forEach((video: HTMLElement) => {
        const img = video.querySelector('.youtube-thumb')
        if (img && !img.classList.contains('has-listener')) {
            img.addEventListener('click', () => {
                const iframe = video.querySelector('iframe');

                let src = iframe.dataset.src;
                src += (src.indexOf('?') === -1) ? '?' : '&';
                iframe.src = src + 'autoplay=1'

                img.classList.add('is-hidden');
                video.classList.add('is-loaded');
            });

            img.classList.add('has-listener');
        }
    });
}
window.handleVideos();
